export default __webpack_public_path__ + "static/media/lightbulb-on-outline.16c6fbcb.svg";